export const sportsUtil = ({
  fetchSID = false,
  matchData = null,
  sname = "asiacup2025",
  currentTab = 1,
  isLive = false,
  currentPath = "/sports",
}) => {
  const sid = 0;
  const statics = {
    sid: sid,
    title: "",
    description: "",
    keywords: "",
    canonical: "",
    h1: "",
    breadcrumb: [],
  };

  if (fetchSID) {
    switch (sname) {
      case "ipl2025":
        return 8307;
      case "indVeng":
        return 8519;
      case "asiacup2025":
        return 13274;
    }
  }
  //
  else {
    if (sname == "ipl2025") {
      let h1Text = "";
      const getSeo = () => {
        switch (currentTab) {
          case 1:
            return {
              title: `${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL 2025 – Head-to-Head, Stats, Match Highlights & More - NewsTak`,
              description: `Get complete details of ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL 2025 match - head-to-head record, scorecard, top performers, match summary, and latest updates.`,
              keywords: `${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL 2025, IPL 2025 ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Scorecard, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Head to Head IPL, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Match Summary, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Playing 11 IPL 2025, Today’s IPL Match ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()}, आईपीएल 2025 ${matchData?.teamA_name?.toUpperCase()} बनाम ${matchData?.teamB_name?.toUpperCase()}, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Highlights IPL 2025`,
              canonical: currentPath,
            };

          case 2: {
            // Summary
            if (isLive) {
              return {
                title: `IPL 2025, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Live Score Today, {date, Month, year} – NewsTak`,
                description: `IPL Match Live Score: ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL 2025 live score with real-time updates, full scorecard, commentary, playing XI, and match stats.`,
                keywords: `${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Live Score IPL 2025, IPL 2025 Live Score Today Match, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Live Cricket Score, IPL 2025 Live Commentary Today, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Scorecard IPL, लाइव आईपीएल स्कोर, IPL लाइव स्कोर ${matchData?.teamA_name?.toUpperCase()} बनाम ${matchData?.teamB_name?.toUpperCase()}, Today IPL Match Live Score`,
                canonical: currentPath,
              };
            }
            return {
              title: `${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()}, ${
                matchData?.match_date_head
              }: Match Summary, Scorecard & Highlights – NewsTak`,
              description: `${matchData?.teamA_name?.toUpperCase()} बनाम ${matchData?.teamB_name?.toUpperCase()}: Catch the complete match summary of ${matchData?.teamA_fullname?.toUpperCase()} vs ${matchData?.teamB_fullname?.toUpperCase()} played on ${
                matchData?.match_date_head
              }. Check final scorecard, top performers, and player stats, and match highlights from IPL 2025.`,
              keywords: `${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL 2025, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Match Summary, ${
                matchData?.match_date_head
              } IPL Match Highlights, IPL 2025 Scorecard Today, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Full Score IPL, IPL Match Today ${
                matchData?.match_date_head
              }, Live Score IPL ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()}, आईपीएल ${
                matchData?.match_date_head
              } स्कोरकार्ड, ${matchData?.teamA_name?.toUpperCase()} बनाम ${matchData?.teamB_name?.toUpperCase()} हाइलाइट्स`,
              canonical: currentPath,
            };
          }

          case 3:
            // Commentary
            return {
              title: `IPL 2025: ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Live Commentary, Score & Updates ${
                matchData?.match_date_head
              } – NewsTak`,
              description: `Get here live ball-by-ball commentary of the ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL 2025 match. Get real-time score updates, key moments, and detailed analysis.`,
              keywords: `${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} live commentary IPL 2025, IPL 2025 live score ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()}, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} ball-by-ball commentary, IPL live updates today match, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL Hindi commentary, आज का आईपीएल मैच लाइव स्कोर, आईपीएल 2025 लाइव कमेंट्री`,
              canonical: currentPath,
            };

          case 4:
            // Scorecard
            return {
              title: `${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL 2025 Scorecard – Full Match Stats & Highlights - NewsTak`,
              description: `Check the complete scorecard of ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} in IPL 2025. Get ball-by-ball updates, batting & bowling stats, and top moments from the match.`,
              keywords: `${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL 2025 Scorecard, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Live Score IPL 2025, IPL 2025 ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Stats, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} Match Highlights, IPL 2025 Today Scorecard, ${matchData?.teamA_name?.toUpperCase()} बनाम ${matchData?.teamB_name?.toUpperCase()} स्कोरकार्ड, ${matchData?.teamA_name?.toUpperCase()} vs ${matchData?.teamB_name?.toUpperCase()} IPL Full Score`,
              canonical: currentPath,
            };

          default:
            return {
              title: "",
              description: "",
              keywords: "",
              canonical: "",
            };
        }
      };
      if (currentTab == 1) {
        h1Text =
          matchData?.teamA_name?.toUpperCase() +
          " vs " +
          matchData?.teamB_name?.toUpperCase() +
          " Match Info";
      }
      if (currentTab == 2) {
        h1Text = !isLive
          ? matchData?.teamA_name?.toUpperCase() +
            " vs " +
            matchData?.teamB_name?.toUpperCase() +
            ", " +
            matchData?.match_date_head +
            " Match Details"
          : matchData?.teamA_name?.toUpperCase() +
            " vs " +
            matchData?.teamB_name?.toUpperCase() +
            " Live Score";
      }
      if (currentTab == 3) {
        h1Text =
          matchData?.teamA_name?.toUpperCase() +
          " vs " +
          matchData?.teamB_name?.toUpperCase() +
          " Live Commentary";
      }
      if (currentTab == 4) {
        h1Text =
          matchData?.teamA_name?.toUpperCase() +
          " vs " +
          matchData?.teamB_name?.toUpperCase() +
          " IPL 2025 Scorecard";
      }
      const { title, description, keywords, canonical } = getSeo();
      statics.title = title;
      statics.canonical = canonical;
      statics.description = description;
      statics.keywords = keywords;
      statics.h1 = h1Text;
      statics.breadcrumb = [
        {
          id: "1",
          title: "Sports",
          canonical_url: "/sports",
          amp_url: "",
        },
        {
          id: "2",
          title: "IPL",
          canonical_url: "/sports/ipl",
          amp_url: "",
        },
        {
          id: "3",
          title: matchData?.match_title || "",
          canonical_url: currentPath,
          amp_url: "",
        },
      ];
    }

    if (sname == "indVeng") {
      let h1Text = "";
      const getSeo = () => {
        switch (currentTab) {
          case 1:
            return {
              title:
                "IND vs ENG Test Series 2025 Info: भारत बनाम इंग्लैंड सीरीज की पूरी जानकारी - NewsTak",
              description:
                "India vs England Test Series 2025 की पूरी जानकारी पाएं: मैच शेड्यूल, स्क्वॉड, वेन्यू, लाइव स्ट्रीमिंग डिटेल्स और लेटेस्ट अपडेट्स हिंदी में सिर्फ NewsTak पर",
              keywords:
                "India vs England 2025 info, IND vs ENG test series 2025 details, India tour of England 2025 full info, इंग्लैंड बनाम भारत 2025 जानकारी, टेस्ट सीरीज शेड्यूल, लाइव स्ट्रीमिंग इंडिया इंग्लैंड",
              canonical: currentPath,
            };

          case 2: {
            // Summary
            if (isLive) {
              return {
                title:
                  "IND vs ENG 2025 Test Series Summary: भारत बनाम इंग्लैंड टेस्ट सीरीज़ का पूरा सारांश - NewsTak",
                description:
                  "India Tour of England 2025 Summary: जानें सीरीज़ के स्कोर, सबसे बड़े हीरो, टर्निंग मोमेंट्स और हर टेस्ट मैच की झलक। भारत बनाम इंग्लैंड टेस्ट सीरीज़ का फुल रिव्यू सिर्फ NewsTak पर",
                keywords:
                  "India vs England 2025 full summary, IND vs ENG test series highlights, India tour of England review, इंग्लैंड बनाम भारत 2025 टेस्ट सीरीज़ सारांश, IND vs ENG key moments, India vs England 2025 score review, cricket summary today",
                canonical: currentPath,
              };
            }
            return {
              title:
                "IND vs ENG 2025 Test Series Summary: भारत बनाम इंग्लैंड टेस्ट सीरीज़ का पूरा सारांश - NewsTak",
              description:
                "India Tour of England 2025 Summary: जानें सीरीज़ के स्कोर, सबसे बड़े हीरो, टर्निंग मोमेंट्स और हर टेस्ट मैच की झलक। भारत बनाम इंग्लैंड टेस्ट सीरीज़ का फुल रिव्यू सिर्फ NewsTak पर",
              keywords:
                "India vs England 2025 full summary, IND vs ENG test series highlights, India tour of England review, इंग्लैंड बनाम भारत 2025 टेस्ट सीरीज़ सारांश, IND vs ENG key moments, India vs England 2025 score review, cricket summary today",
              canonical: currentPath,
            };
          }

          case 3:
            // Commentary
            return {
              title:
                "IND vs ENG Test Series Live Commentary 2025: भारत बनाम इंग्लैंड टेस्ट लाइव कमेंट्री, बॉल-बाय-बॉल अपडेट्स - NewsTak",
              description:
                "Catch ball-by-ball live commentary of India vs England Test Series 2025 (भारत बनाम इंग्लैंड टेस्ट मैच लाइव). Stay updated with real-time score updates, expert insights, and Hindi commentary coverage only on NewsTak.",
              keywords:
                "IND vs ENG live commentary, India vs England 2025 ball by ball, IND vs ENG live updates, IND vs ENG Test commentary Hindi, cricket live Hindi, इंग्लैंड बनाम भारत लाइव कमेंट्री, क्रिकेट हिंदी कमेंट्री, IND vs ENG ball by ball updates, India tour of England live coverage",
              canonical: currentPath,
            };

          case 4:
            // Scorecard
            return {
              title:
                "IND vs ENG 2025 Test Series Scorecard: भारत बनाम इंग्लैंड टेस्ट स्कोर, Full Match Stats & Highlights - NewsTak",
              description:
                "Check the full India vs England Test Series 2025 scorecard (भारत बनाम इंग्लैंड टेस्ट स्कोरकार्ड). Get live scores, batting & bowling stats, partnerships, fall of wickets, and match summaries in Hindi only on NewsTak.",
              keywords:
                "India vs England 2025 scorecard, IND vs ENG 2025 live score, ENG vs IND Test match stats, live cricket score India vs England, IND vs ENG match summary, IND vs ENG player stats, इंग्लैंड बनाम भारत लाइव स्कोरकार्ड, क्रिकेट स्कोर इंडिया इंग्लैंड",
              canonical: currentPath,
            };

          default:
            return {
              title: "",
              description: "",
              keywords: "",
              canonical: "",
            };
        }
      };
      if (currentTab == 1) {
        h1Text = "IND vs ENG Test Series 2025 Info";
      }
      if (currentTab == 2) {
        h1Text = `IND vs ENG 2025 Series ${isLive ? "Live" : "Summary"}`;
      }
      if (currentTab == 3) {
        h1Text = "IND vs ENG Live Commentary 2025";
      }
      if (currentTab == 4) {
        h1Text = "IND vs ENG 2025 Test Series Scorecard";
      }
      const { title, description, keywords, canonical } = getSeo();
      statics.title = title;
      statics.canonical = canonical;
      statics.description = description;
      statics.keywords = keywords;
      statics.h1 = h1Text;
      statics.breadcrumb = [
        {
          id: "1",
          title: "Sports",
          canonical_url: "/sports",
          amp_url: "",
        },
        {
          id: "2",
          title: "Cricket",
          canonical_url: "/sports/cricket",
          amp_url: "",
        },
        {
          id: "3",
          title: matchData?.match_title || "",
          canonical_url: currentPath,
          amp_url: "",
        },
      ];
    }

    // asia cup 2025
    if (sname == "asiacup2025") {
      let h1Text = "";
      const getSeo = () => {
        switch (currentTab) {
          case 1:
            return {
              title: ` Asia Cup 2025: Schedule, Results, Points Table, Live Scores & News - Newstak`,
              description: `Asia Cup 2025: Get complete coverage of Asia Cup 2025 - live scores, fixtures, results, stats, points table and match updates. Stay tuned for the latest Asia Cup cricket news from India and Asia.`,
              keywords: `Asia Cup 2025, Asia Cup Live, Asia Cup Cricket Schedule, Asia Cup Points Table, Asia Cup News, Asia Cup India, एशिया कप 2025`,
              canonical: currentPath,
            };

          case 2:
            return {
              title: `Asia Cup 2025 Player Stats: Top Scorers, Wickets & Records - Newstak`,
              description: `Asia Cup 2025 Stats: Explore Asia Cup 2025 cricket stats – top run scorers, leading wicket-takers, team records, partnerships and player performance updates.`,
              keywords: `Asia Cup 2025 Stats, Asia Cup Records, Asia Cup Top Scorers, Asia Cup Wickets, Asia Cup Player Performance, एशिया कप 2025 स्टैट्स`,
              canonical: currentPath,
            };

          case 3:
            // Commentary
            return {
              title: `Asia Cup 2025 Schedule & Fixtures: Match Dates, Venues & Results - Newstak`,
              description: `Asia Cup 2025 Match Schedule & Fixtures: Find the complete Asia Cup 2025 match schedule, fixtures, venues, timings and live results. Stay updated on upcoming matches across India and Asia.`,
              keywords: `Asia Cup 2025 Schedule, Asia Cup Fixtures, Asia Cup Results, Asia Cup Match Dates, Asia Cup Venues, Asia Cup 2025 Match Schedule & Fixtures, एशिया कप 2025 शेड्यूल`,
              canonical: currentPath,
            };

          case 4:
            // Scorecard
            return {
              title: `Asia Cup 2025 Points Table: Team Standings & Rankings - Newstak`,
              description: `Asia Cup 2025 Points Table: Check the latest Asia Cup 2025 points table with team standings, match wins, losses, net run rate and rankings updated live.`,
              keywords: `Asia Cup 2025 Points Table, Asia Cup Team Standings, Asia Cup Rankings, Asia Cup Live Points, एशिया कप 2025 अंक तालिका`,
              canonical: currentPath,
            };

          default:
            return {
              title: "",
              description: "",
              keywords: "",
              canonical: "",
            };
        }
      };
      if (currentTab == 1) {
        h1Text = "एशिया कप 2025";
      }
      if (currentTab == 2) {
        h1Text = "एशिया कप 2025 स्टैट्स";
      }
      if (currentTab == 3) {
        h1Text = "एशिया कप 2025 शेड्यूल";
      }
      if (currentTab == 4) {
        h1Text = "एशिया कप 2025 अंक तालिका";
      }
      const { title, description, keywords, canonical } = getSeo();
      statics.title = title;
      statics.canonical = canonical;
      statics.description = description;
      statics.keywords = keywords;
      statics.h1 = h1Text;
      statics.breadcrumb = [
        {
          id: "1",
          title: "Sports",
          canonical_url: "/sports",
          amp_url: "",
        },
        {
          id: "2",
          title: "Asia Cup 2025",
          canonical_url: "/sports/asia-cup-2025",
          amp_url: "",
        },
        {
          id: "3",
          title:
            matchData?.match_title ||
            (() => {
              const lastSegment = currentPath?.split("/")[3];

              if (!lastSegment) return "";

              const cleanStr = lastSegment
                ?.split("?")[0]
                ?.split("-")
                ?.join(" ");

              return cleanStr?.charAt(0)?.toUpperCase() + cleanStr?.slice(1);
            })(),
          canonical_url: currentPath,
          amp_url: "",
        },
      ];
    }
    return statics;
  }
};
